import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useTutorKanbanStore } from './store'

interface TutorKanbanLinksReturn {
  refTutorAppLink: ComputedRef<string>
  refDiscordLink: ComputedRef<string>
  refRespondLink: ComputedRef<string>
}

export const useTutorKanbanLinks = (): TutorKanbanLinksReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const refTutorAppLink = computed<string>(() => tutorKanbanStore.getTutor?.tutor_app_link ?? '')
  const refDiscordLink = computed<string>(() => tutorKanbanStore.getTutor?.tutor_discord_link ?? '')
  const refRespondLink = computed<string>(() => tutorKanbanStore.getTutor?.tutor_respond_link ?? '')

  return {
    refTutorAppLink,
    refDiscordLink,
    refRespondLink,
  }
}
